import React from 'react';
import { SiteNav, useRevealOnScroll, setPageMeta } from './Shell.jsx';
import { Footer } from './Sections.jsx';
import { ModalRoot } from './Forms.jsx';
import { CookieConsentRoot } from './CookieConsent.jsx';

export function PageShell({ currentPath, title, description, canonical, image, children }) {
  React.useEffect(() => { setPageMeta({ title, description, canonical, image }); }, [title, description, canonical, image]);
  useRevealOnScroll();
  return <><SiteNav currentPath={currentPath} variant="transparent" />{children}<Footer /><ModalRoot /><CookieConsentRoot /></>;
}
